var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',{staticClass:"content-padding"},[_c('v-list-item-title',{staticClass:"autocomplete-result",domProps:{"innerHTML":_vm._s(_vm.formatItem(_vm.data.item.name))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }